import React, { FC } from "react";
import { RouterParamType } from "@/model/navModel";
import { TableBoxAdded } from "./TableBoxAdded";



export const BoxDetail: FC<RouterParamType> = ({ formRef, ...detailsInfo }) => {
    return (
        <TableBoxAdded  {...detailsInfo} />
    )
}